// extracted by mini-css-extract-plugin
module.exports = {"containerBotaoWhats":"style-module--container-botao-whats--2scV3"};